import { useCallback, useMemo } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { NewRechargeStep } from '../types';
import { STEP_CONFIGS } from './constants/stepOrder';
import { useStepDataFormatter } from './useStepDataFormatter';
import { createStepStatusManager } from './utils/stepStatusManager';
export function useNewRechargeSteps({ currentStep, formData, onStepChange, product, }) {
    const { t } = useTranslation();
    const { getStepData } = useStepDataFormatter(formData, product);
    const isDeliveryAddressSkipped = formData.requiresCardDelivery === false;
    const stepStatusManager = useMemo(() => createStepStatusManager(currentStep), [currentStep]);
    const steps = useMemo(() => {
        const visibleConfigs = isDeliveryAddressSkipped
            ? STEP_CONFIGS.filter(config => config.id !== NewRechargeStep.DELIVERY_ADDRESS)
            : STEP_CONFIGS;
        return visibleConfigs.map((config, index) => ({
            number: index + 1,
            id: config.id,
            title: t(config.translationKey),
            status: stepStatusManager.getStepStatus(config.id),
        }));
    }, [isDeliveryAddressSkipped, stepStatusManager, t]);
    const canNavigateToStep = useCallback((step) => {
        if (isDeliveryAddressSkipped && step === NewRechargeStep.DELIVERY_ADDRESS) {
            return false;
        }
        return stepStatusManager.canNavigateToStep(step);
    }, [isDeliveryAddressSkipped, stepStatusManager]);
    const navigateToStep = useCallback((step) => {
        if (canNavigateToStep(step)) {
            onStepChange(step);
        }
    }, [canNavigateToStep, onStepChange]);
    return {
        steps,
        isDeliveryAddressSkipped,
        canNavigateToStep,
        navigateToStep,
        getStepData,
    };
}
